import { useEffect, useState } from "react"


type typeMultipleInputData ={
    getValues:(values:string[])=>void,
    inputValues?:string[]
}

const MultipleInput =({getValues,inputValues}:typeMultipleInputData)=>{
    const [count,setCount] = useState(1)
    const [values, setValues] = useState<string[]>([])

    useEffect(()=>{
        if (inputValues != undefined) {
            if (inputValues.length >0) {
                setCount(inputValues.length)
                setValues(inputValues)
            }
        }
    },[inputValues])

    useEffect(()=>{
        getValues(values);
    },[values])

    const addOptions = () => {
        setCount(count + 1);
    };

    const removeOption = () => {
        if (count > 1) {
            setInputValue("",count-1)
            setCount(count - 1);
        }
    };

    const setInputValue = (value:string,index:number)=>{
        let set_value = values.filter((item,key)=>{
            return key===index
        })
        if (set_value.length ==0) {
            setValues([...values, value])
        }else{
            const newValues = values.map((item,key)=>{
                if (key===index) {
                    return value
                }else{
                    return item
                }
            }).filter(item => item !== '');
            setValues(newValues);
        }
    }

    return (
        <div>
            {
                 Array.from(Array(count).keys()).map((i) => (
                    <div key={i} className="flex gap-1 mb-1">
                        <input value={values[i]} onChange={(e)=> setInputValue(e.target.value,i)} className="form-input-2 flex-grow" type="text" />
                        {   (i==0)?
                            <button  onClick={()=>addOptions()} className=" btn-light px-2"> 
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2Z"/></svg>
                            </button>:
                            <button  onClick={()=>removeOption()} className=" btn-light px-2"> 
                                 <svg  xmlns="http://www.w3.org/2000/svg" className=" text-red-600 cursor-pointer" width="18" height="18" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 7h16m-10 4v6m4-6v6M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-12M9 7V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3"/></svg>
                           </button>
                        }
                    </div>
                ))
            }
        </div>
       
    )
}

export default MultipleInput